import { MdExitToApp as ExitToApp } from 'react-icons/md';
import { MdHowToReg as HowToReg } from 'react-icons/md';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth0 } from '@auth0/auth0-react';

//#region COMPONENT
/**
 * @param {object} props Component properties
 * @returns An authentification button
 */
const AuthButton = () => {
  //#region INITIALIZATION
  // hooks
  const { user } = useAuth0();

  // Hooks init
  const [t] = useTranslation('Navbar');
  const { logout } = useAuth0();

  // Dispatch

  // Manage the user deconnexion
  const handleDisconnect = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };
  //#endregion

  return (
    <>
      <div className="AZmedNavbar-sectionDesktop">
        <button
          aria-haspopup="true"
          className="AZmedNavbar-navButton"
        >
          <HowToReg style={{ marginRight: '5px' }} />
          {user ? `${user.given_name} ${user.family_name}` : null}
        </button>
      </div>
      <button
        className="AZmedNavbar-navButton"
        onClick={handleDisconnect}
      >
        <ExitToApp style={{ marginRight: '5px' }} />
        <div className="AZmedNavbar-sectionDesktop">{t('Sign out')}</div>
      </button>
    </>
  );
};
//#endregion

export { AuthButton };
